import {connect} from 'react-redux';
import React from 'react';
import {compose} from 'redux';
import {ITenant} from '../../App';
import AuthorizedImage from '../images';

interface AppSpinnerProps {
  style?: any;
  type?: string;
  className?: string;
  tenant: ITenant;
}

function AppSpinner(props: AppSpinnerProps) {
  const spinner =
    props.type === 'grey' ? (
      <AuthorizedImage
        requiresAuthorization={false}
        className={props.className}
        source={`${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL_PUBLIC}${props.tenant?.spinnerPortalGreyBackground}`}
        style={props.style}
      />
    ) : props.type === 'transparent' ? (
      <AuthorizedImage
        requiresAuthorization={false}
        className={props.className}
        source={`${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL_PUBLIC}${props.tenant?.spinnerPortalWhiteBackground}`}
        style={props.style}
      />
    ) : (
      <AuthorizedImage
        requiresAuthorization={false}
        className={props.className}
        source={`${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL_PUBLIC}${props.tenant?.spinnerPortalWhiteBackground}`}
        style={props.style}
      />
    );
  return spinner;
}

const mapStateToProps = ({tenant}: any) => ({
  tenant: tenant.value,
});

export default compose(connect(mapStateToProps)(AppSpinner));
